import type { TestThreshold } from "@/types/test";

/**
 * A new threshold starts right after the highest existing range, so adding two
 * in a row never produces an instant overlap (both used to start at 0-0).
 * Ranges are inclusive integers: after 0-10 comes 11.
 */
export function nextThreshold(thresholds: TestThreshold[], maxScore: number): TestThreshold {
  const highest = thresholds.reduce((max, t) => Math.max(max, t.maxScore), -1);
  const minScore = highest + 1;
  return { minScore, maxScore: Math.max(minScore, maxScore), label: "" };
}
